import { logWrapper } from '../../utils';

export default {
  workflowBaseController: [
    'runtimeConstant',
    '$state',
    '$rootScope',
    '$window',
    'PermPermissionStore',
    function (
      runtimeConstant,
      $state,
      $rootScope,
      $window,
      PermPermissionStore
    ) {
      'use strict';

      function currentState() {
        return $state.current.name;
      }

      function filterMenus(menu) {
        return menu && menu.canShow();
      }

      function run() {
        try {
          $rootScope.menus = [
            {
              title: 'WORKFLOWS',
              icon: 'md md-call-made',
              action: $state.go,
              type: 'flows.base.models',
              canShow: function () {
                return PermPermissionStore.hasPermissionDefinition(
                  'ManageWorkflows'
                );
              },
            },
            {
              title: 'FLOWS EXECUTIONS',
              icon: 'md md-repeat',
              action: $state.go,
              type: 'flows.base.executions',
              canShow: function () {
                return PermPermissionStore.hasPermissionDefinition(
                  'ManageWorkflows'
                );
              },
            },
            {
              title: 'MY TASKS',
              icon: 'md md-notifications-none',
              action: $state.go,
              type: 'flows.base.tasks',
              canShow: function () {
                return true;
              },
            },
          ];

          $rootScope.currentState = logWrapper(
            currentState,
            runtimeConstant.isDebugControllersInternals
          );
          $rootScope.filterMenus = logWrapper(
            filterMenus,
            runtimeConstant.isDebugControllersInternals
          );

          $window.onbeforeunload = null;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
